import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FieldType } from '../../models';
import { SeparateStayDateDesktop } from './Desktop/DateDesktop';
import { withPageContext } from '../../utils/PageContext';
import { getSeparateStayEnabled } from '../../redux/currentSearch/selectors';

export class SeparateStayCalendars extends Component {
    state = {
        fieldFocused: null,
    };

    onChangeFocusSeparateStay = (field, focus, index) => {
        const leg = index ? index : 0;
        if (focus) {
            this.setState({
                fieldFocused: { leg, field },
            });
        } else {
            this.setState({ fieldFocused: false });
        }
    };

    onChangeFocusSeparateStayReturnLeg = (field, focus) => {
        this.onChangeFocusSeparateStay(field, focus, 1);
    };

    render() {
        const { show } = this.props;
        const { fieldFocused } = this.state;
        const fieldOpen = fieldFocused ? fieldFocused.field : null;
        const legFieldOpen = fieldFocused ? fieldFocused.leg : null;
        const firstIndex = 0;
        const secondIndex = 1;

        return show && (
            <React.Fragment>
                <div className="SegmentManagerDP-SSDeparture odf-space-inner-top-s">
                    <SeparateStayDateDesktop
                        index={firstIndex}
                        isDatesRangeShown
                        open={fieldOpen === FieldType.DATE && legFieldOpen === 0}
                        onChangeFocus={this.onChangeFocusSeparateStay}
                        placeholderKey="calendar.departureDateSeparateStay"
                        roundedCornersFirst
                    />
                </div>
                <div className="SegmentManagerDP-SSReturn odf-calendar-end odf-space-inner-top-s">
                    <SeparateStayDateDesktop
                        index={secondIndex}
                        isDatesRangeShown
                        open={fieldOpen === FieldType.DATE && legFieldOpen === 1}
                        onChangeFocus={this.onChangeFocusSeparateStayReturnLeg}
                        placeholderKey="calendar.returnDateSeparateStay"
                        roundedCornersLast
                    />
                </div>
            </React.Fragment>
        );
    }
}

SeparateStayCalendars.propTypes = {
    show: PropTypes.bool.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    show: getSeparateStayEnabled,
});

export const ConnectedSeparateStayCalendars = connect(mapStateToPropsSelector)(withPageContext(SeparateStayCalendars));
